/**
 * Analytics Components Index
 * Export all analytics components
 */

export { default as AdvancedLineChart } from './AdvancedLineChart';
export { default as AdvancedBarChart } from './AdvancedBarChart';
export { default as AnalyticsDashboard } from './AnalyticsDashboard';
export { default as PredictionChart } from './PredictionChart';
export { default as InsightsPanel } from './InsightsPanel';
export { default as AnomalyDetector } from './AnomalyDetector';
export { default as GoogleAnalytics } from './GoogleAnalytics';

// Analytics tracking functions
export const trackEvent = (eventName, properties = {}) => {
  console.log('Track Event:', eventName, properties);
  // Implement actual tracking logic here
};

export const trackUpgrade = (tier, properties = {}) => {
  console.log('Track Upgrade:', tier, properties);
  trackEvent('upgrade', { tier, ...properties });
};

export const trackRegionChange = (region, properties = {}) => {
  console.log('Track Region Change:', region, properties);
  trackEvent('region_change', { region, ...properties });
};

export const trackPricingView = (properties = {}) => {
  console.log('Track Pricing View:', properties);
  trackEvent('pricing_view', properties);
};
